import styled from '@emotion/styled';

export const LifeStyleWrapper = styled.div``;
